import { NOTIFICATION_TYPE } from '../../../../constants/common'

import {
  DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_COST_IS_OUTDATED,
  DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_ERROR,
  DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_INFO,
  DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_NO_CALCULATION,
  DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_NOT_ENOUGH_CREDITS,
  DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_SUCCESS,
  DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_UNAVAILABLE,
  DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_VALID_INFO,
  DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_VALIDATION_ERRORS,
} from './DocFlowSendingEpostSettingsWidget.constants'

export function getDocFlowSendingEpostSettingsWidgetNotifications({
  t,
  onOpenSupportData,
}) {
  return {
    costIsOutdated: {
      id: DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_COST_IS_OUTDATED,
      text: t(
        'DocumentStapling.SendingPhaseEpostWidgetCostIsOutdatedNotificationKey'
      ),
      type: NOTIFICATION_TYPE.error,
    },
    error: {
      id: DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_ERROR,
      text: t('DocumentStapling.SendingPhaseEpostWidgetErrorNotificationKey'),
      type: NOTIFICATION_TYPE.error,
    },
    info: {
      id: DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_INFO,
      text: t('DocumentStapling.SendingPhaseEpostWidgetInfoNotificationKey'),
      type: NOTIFICATION_TYPE.info,
    },
    noCalculation: {
      id: DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_NO_CALCULATION,
      text: t(
        'DocumentStapling.SendingPhaseEpostWidgetNoCalculationNotificationKey'
      ),
      type: NOTIFICATION_TYPE.error,
    },
    notEnoughCredits: {
      id: DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_NOT_ENOUGH_CREDITS,
      text: t(
        'DocumentStapling.SendingPhaseEpostWidgetNotEnoughCreditsNotificationKey'
      ),
      type: NOTIFICATION_TYPE.error,
    },
    notEnoughCreditsWithLink: {
      id: DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_NOT_ENOUGH_CREDITS,
      linkProps: {
        Component: 'span',
        title: t('Epost.NotificationContactSupportLinkKey'),
        onClick: onOpenSupportData,
      },
      text: t(
        'DocumentStapling.SendingPhaseEpostWidgetNotEnoughCreditsNotificationKey'
      ),
      type: NOTIFICATION_TYPE.error,
    },
    success: {
      id: DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_SUCCESS,
      text: t('DocumentStapling.SendingPhaseEpostWidgetSuccessNotificationKey'),
      type: NOTIFICATION_TYPE.success,
    },
    unavailable: {
      id: DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_UNAVAILABLE,
      text: t(
        'DocumentStapling.SendingPhaseEpostWidgetUnavailableNotificationKey'
      ),
      type: NOTIFICATION_TYPE.info,
    },
    validationErrors: {
      id: DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_VALIDATION_ERRORS,
      text: t(
        'DocumentStapling.SendingPhaseEpostWidgetValidationErrorsNotificationKey'
      ),
      type: NOTIFICATION_TYPE.error,
    },
    validInfo: {
      id: DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_VALID_INFO,
      text: t(
        'DocumentStapling.SendingPhaseEpostWidgetNoCalculationNotificationKey'
      ),
      type: NOTIFICATION_TYPE.warning,
    },
  }
}
